import { useEffect, useState } from "react";
import { formatDate, formatDateTimeToTime, SweetAlertShow } from "../../../master/Master";
// import { studentTransportTransferHistory } from "../../../../api/StudentDetails";
import { Pill } from "./Master";

const Skeleton = ({ w = "100%", h = "14px" }) => (
  <span
    className="placeholder"
    style={{
      width: w,
      height: h,
      display: "inline-block",
      borderRadius: "6px",
    }}
  />
);

export default function TransportTransferHistoryModal({ entry, onClose }) {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  const fetchHistory = async () => {
    setLoading(true);
    try {
    //   const response = await studentTransportTransferHistory(entry?.id);
    //   if (response.data.status) {
    //     setRows(response.data.data || []);
    //   } else {
    //     SweetAlertShow("info", "Warning", response.data.message);
    //   }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message || error?.response?.message || error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (entry?.id) {
      fetchHistory();
    }
  }, [entry?.id]);

  return (
    <div
      className="modal d-block"
      style={{ background: "rgba(0,0,0,.5)" }}
      tabIndex={-1}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content rounded-4 border-0 overflow-hidden">
          <div className="modal-header border-0 pb-0">
            <div>
              <h5 className="modal-title fw-bold d-flex align-items-center gap-2">
                <i className="ri-history-line text-primary"></i>
                Transport Transfer History
              </h5>

              <div className="d-flex flex-wrap gap-2 mt-2">
                <Pill
                  icon="ri-bus-2-line"
                  color="primary"
                  label="Bus"
                  value={entry?.bus?.bus_number || "-"}
                />
                <Pill
                  icon="ri-map-pin-line"
                  color="success"
                  label="Current Stop"
                  value={entry?.stop?.stop_name || "-"}
                />
                <Pill
                  icon="ri-calendar-line"
                  color="info"
                  label="Payment"
                  value={entry?.payment_type || "-"}
                />
              </div>
            </div>

            <button type="button" className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body">
            {loading ? (
              <div className="placeholder-glow d-flex flex-column gap-2">
                <Skeleton h="20px" />
                <Skeleton h="20px" />
                <Skeleton h="20px" />
                <Skeleton h="20px" />
              </div>
            ) : rows.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>From Stop</th>
                      <th>To Stop</th>
                      <th>Transfer Date</th>
                      <th>Time</th>
                      <th>Transfer By</th>
                      <th>Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => {
                      const fromStop = row?.stop;
                      const toStop = rows[index + 1]?.stop;

                      return (
                        <tr key={row.id}>
                          <td>{index + 1}</td>
                          <td>{fromStop?.stop_name || "-"}</td>
                          <td>
                            {toStop ? (
                              <>
                                {toStop?.stop_name}
                                <br />
                                <small className="text-muted">{toStop?.bus?.bus_number}</small>
                              </>
                            ) : (
                              <span className="badge bg-success">Current Route</span>
                            )}
                          </td>
                          <td>{formatDate(row?.transfer_datetime)}</td>
                          <td>{formatDateTimeToTime(row?.transfer_datetime)}</td>
                          <td>{row?.transfer_by?.name || "-"}</td>
                          <td>{row?.reason || "-"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5">
                <i className="ri-inbox-line fs-1 text-muted"></i>
                <h6 className="mt-2">No Transfer History Found</h6>
              </div>
            )}
          </div>

          <div className="modal-footer border-0">
            <button className="btn btn-outline-secondary" onClick={onClose}>
              <i className="ri-close-line me-1"></i>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}